export const MAX_FILE_SIZE = 104857600; // (100 * 1024 * 1024 bytes) = 100mb
export const SAME_FILE_MARKER = 'same';
export const MAX_NUMBER_OF_FILES = 10;

export const CUSTOMIZATION_IMAGE_MAX_SIZE = 26214400;
export const CUSTOMIZATION_IMAGE_ACCEPT = '.png,.jpg,.jpeg';
export const CUSTOMIZATION_MAX_BACKGROUNDS = 4;
